import { render } from "./Admin.vue?vue&type=template&id=0f348d68&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=0f348d68&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shawn\\sloppy-golf\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f348d68"]])

export default __exports__